import * as occlTemplates from './occl';

type TemplatesType = typeof occlTemplates;

const templates = {
  occl: occlTemplates as unknown as TemplatesType,
};

export default templates;
